import {ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, effect, ElementRef, inject, input, InputSignal, Renderer2} from '@angular/core';

import {IconPrefix} from '../fa-icon/data/fa-icon.types';

@Component({
	selector: 'unicon',
	imports: [],
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniconComponent {
	/* --------------------------------------------------  DOM -------------------------------------------------- */

	/* ------------------------------------------  Types and Constants ------------------------------------------ */

	/* ------------------------------------------------  Inputs ------------------------------------------------ */
	readonly faStyle: InputSignal<IconPrefix> = input<IconPrefix>('fas');
	/** Unicode value of font awesome icon */
	readonly icon: InputSignal<string> = input.required<string>();
	readonly styleClass: InputSignal<string> = input<string>();
	/* ------------------------------------------------  Signals ------------------------------------------------ */
	protected readonly asUnicode$ = computed(() => {
		let iconStr = this.icon();
		iconStr = iconStr.startsWith('&#x') ? iconStr : `&#x${iconStr}`;
		iconStr = iconStr.endsWith(';') ? iconStr : `${iconStr};`;
		return iconStr;
	});
	/* ------------------------------------------------  Methods ------------------------------------------------ */
	protected readonly String = String;
	/* ------------------------------------------ PROVIDERS / SERVICES ------------------------------------------ */
	private readonly elementRef: ElementRef = inject(ElementRef);
	/* ------------------------------------------------  Outputs ------------------------------------------------ */
	private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
	/* -------------------------------------------------- Data -------------------------------------------------- */
	private readonly renderer2: Renderer2 = inject(Renderer2);

	/* ----------------------------------------------- Lifecycle Hooks ----------------------------------------------- */

	/* ------------------------------------------------  Constructor ------------------------------------------------ */
	constructor() {
		effect(() => {
			const icon = this.asUnicode$();
			if (icon) {
				if (this.elementRef.nativeElement.children.length > 0) this.elementRef.nativeElement.innerHTML = '';
				const iconElement = this.renderer2.createElement('i');
				iconElement.classList.add('fa');
				iconElement.classList.add(`${this.faStyle()}`);
				const styleClass = this.styleClass();
				if (styleClass) iconElement.classList.add(styleClass);
				iconElement.innerHTML = icon;
				this.renderer2.appendChild(this.elementRef.nativeElement, iconElement);
				this.cdr.detectChanges();
			}
		});
	}
}
